export default function Help() {
    return (
        <div>
            <h2>Help</h2>
        </div>
    )
}
